'use strict';



const $ = require('jquery');
const inViewport = require('in-viewport');
const getFragment = require('./get-fragment');
const $loanViewer = $('.js-loan-viewer');
const $carousel = $loanViewer.find('.js-loan-viewer-carousel');
const $control = $loanViewer.find('[data-control]');
const $switcher = $loanViewer.find('[data-switch]');
const switcherActiveClassName = 'c-tab-group__item__inner--active';
const loadingClassName = 'is-loading';
const offset = 300;
const slidesToShow = 3;
let initialised = false;
const loadedImages = [];



if($loanViewer.length > 0) {
	inViewport($loanViewer[0], { offset }, loadContent.bind(null, 'live'));
}



function init() {

	$carousel.slick({
		infinite: true,
		speed: 250,
		centerMode: true,
		variableWidth: true,
		arrows: false,
		slidesToShow
	});

	lazyLoad();
	$carousel.on('afterChange', lazyLoad);
	initialised = true;
	appendLoadedImages();

}



$control.on('click', function() {

	const methods = {
		left: 'slickPrev',
		right: 'slickNext'
	};

	const control = $(this).data('control');
	const method = methods[control];

	if(method) {
		$carousel.slick(method);
	}

});



$switcher.on('click', function(e) {

	e.preventDefault();

	const $this = $(this);
	const type = $this.data('switch');

	$switcher.removeClass(switcherActiveClassName);
	$this.addClass(switcherActiveClassName);
	loadContent(type);

});



function lazyLoad() {

	const current = $carousel.slick('slickCurrentSlide');
	const $slides = $carousel.slick('getSlick').$slides;
	const length = $slides.length;
	const queue = [];

	let previous = [ current - slidesToShow, current ];
	let next = [ current, current + slidesToShow ];

	if(previous[0] < 0) {
		previous[0] = length + previous[0];
		previous[1] = length;
	}

	$.merge($slides.slice(...previous), $slides.slice(...next))
		.each(function() {

			const $slide = $(this);
			const $image = $slide.find('[data-lazy]');
			const src = $image.attr('data-lazy');

			if(loadedImages.indexOf(src) > -1) {
				return;
			}

			queue.push(src);

		});

	queue.forEach(src => {
		loadedImages.push(src);
		appendLoadedImages(src);
	});

}



function loadContent(type) {

	$loanViewer.addClass(loadingClassName);

	getFragment('Loan/Carousel', { type })
		.done(res => {
			$loanViewer.removeClass(loadingClassName);
			setCarouselContent(res);
		});

}



function appendLoadedImages(src) {

	const append = src => $(`[data-lazy='${src}']`).css({ backgroundImage: `url('${src}')` });

	return src ?
		append(src) :
		loadedImages.forEach(append);

}



function setCarouselContent(content) {

	if(!initialised) {
		init();
	}

	$carousel
		.slick('unslick')
		.html(content);

	init();

}